module.exports = __webpack_public_path__ + "media/cable_video.f141e618.mp4";